import React, { createContext, useContext, useMemo, useState, useCallback } from 'react';
import PropTypes from 'prop-types';

const ModalContext = createContext({
    modals: {},
    openModal: () => {},
    closeModal: () => {},
});

export const useModal = () => useContext(ModalContext);

export const ModalProvider = ({ children }) => {
    const [modals, setModals] = useState({
        contact: false,
        pms: false,
        ownerRez: false,
    });

    const openModal = useCallback((modalName) => {
        setModals((prevModals) => ({ ...prevModals, [modalName]: true }));
    }, []);

    const closeModal = useCallback((modalName) => {
        setModals((prevModals) => ({ ...prevModals, [modalName]: false }));
    }, []);

    const contextValue = useMemo(
        () => ({
            modals,
            openModal,
            closeModal,
        }),
        [modals, openModal, closeModal]
    );

    return <ModalContext.Provider value={contextValue}>{children}</ModalContext.Provider>;
};

ModalProvider.propTypes = {
    children: PropTypes.node,
};
